"use strict";

var _classCallCheck = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Extension_1 = __importDefault(require("../lib/Extension"));

var Node =
/*#__PURE__*/
function (_Extension_1$default) {
  _inherits(Node, _Extension_1$default);

  function Node() {
    _classCallCheck(this, Node);

    return _possibleConstructorReturn(this, _getPrototypeOf(Node).apply(this, arguments));
  }

  _createClass(Node, [{
    key: "toMarkdown",
    value: function toMarkdown(state, node) {
      console.error("toMarkdown not implemented", state, node);
    }
  }, {
    key: "parseMarkdown",
    value: function parseMarkdown() {
      return;
    }
  }, {
    key: "type",
    get: function get() {
      return "node";
    }
  }, {
    key: "markdownToken",
    get: function get() {
      return "";
    }
  }]);

  return Node;
}(Extension_1.default);

exports.default = Node;